module.exports = __webpack_public_path__ + "img/BEA-HERO.fa5f522f.jpg";